import React, { useState, useMemo, useCallback /*, useEffect*/ } from "react";
import { flushSync } from "react-dom";
import { Dialog } from "primereact/dialog";
import { FileUpload } from "primereact/fileupload";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
// import { Card } from "primereact/card";
// import { Badge } from "primereact/badge";
import "../styles/CargarListaDeEmpaqueModal.css";
import TotalesEncabezadoListaEmpaque from "../Componentes/Totalesencabezadolistaempaque";
import { fetchWithAuth, API_URL } from "../Componentes/fetchWithAuth";
import LoadingOverlay from "../Componentes/LoadingOverlay";

//const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

const CargarListaDeEmpaqueModal = ({
  isOpen,
  onClose,
  pedido,
  onSaveSuccess,
  language,
}) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewData, setPreviewData] = useState([]); // Datos cargados para previsualización
  const [loading, setLoading] = useState(false);
  const toast = React.useRef(null);

  // **Encabezados esperados**
  const columnasEsperadas = useMemo(
    () => [
      { field: "nroCaja", header: "NRO CAJA", width: "100px" },
      { field: "RefInterna", header: "REF PRODUCTO", width: "150px" },
      { field: "RefProveedor", header: "REF PROVEEDOR", width: "150px" },
      { field: "ImagenProducto", header: "FOTO", width: "180px" },
      { field: "MarcaCaja", header: "MARCA", width: "120px" },
      { field: "Descripcion", header: "DESCRIPCION", width: "350px" },
      { field: "Material", header: "MATERIAL", width: "120px" },
      { field: "Serial", header: "SERIAL", width: "120px" },
      { field: "MarcaProducto", header: "MARCA (PRODUCTO)", width: "150px" },
      { field: "UnidadMedida", header: "UNIDAD MEDIDA", width: "100px" },
      { field: "Modelo", header: "MODELO", width: "150px" },
      { field: "PesoBruto", header: "PESO BRUTO", width: "110px" },
      { field: "CantCajas", header: "CANT CAJAS", width: "100px" },
      { field: "CantPiezasPorCaja", header: "PCS / CAJA", width: "100px" },
      { field: "CantTotal", header: "CANT TOTAL", width: "100px" },
      { field: "CBMTotal", header: "CBM TOTAL", width: "100px" },
      { field: "CubCaja", header: "CUBICAJE / CAJA", width: "120px" },
      { field: "PesoCaja", header: "PESO / CAJA", width: "110px" },
      { field: "TipoMcia", header: "TIPO MCIA", width: "100px" },
      { field: "Importador", header: "IMPORTADOR", width: "150px" },
    ],
    [],
  );

  const translations = {
    es: {
      titulo: "Cargar Lista de Empaque",
      subir: "Subir Archivo",
      selarchivo: "Seleccionar archivo",
      cancelar: "Cancelar",
      guardar: "Guardar",
      advertencia: "Advertencia",
      errorArchivo: "Por favor seleccione un archivo para subir.",
      cargadoExito: "Archivo cargado con éxito.",
      cargadoError: "Error al cargar el archivo.",
      advertenciaEstado:
        "El pedido no está en un estado válido para cargar un archivo.",
      noDatos: "No hay datos cargados.",
      guardadoExito: "Datos guardados con éxito.",
      guardadoError: "Error al guardar los datos.",
    },
    en: {
      titulo: "Upload Packing List",
      subir: "Upload File",
      selarchivo: "Select file",
      cancelar: "Cancel",
      guardar: "Save",
      advertencia: "Warning",
      errorArchivo: "Please select a file to upload.",
      cargadoExito: "File uploaded successfully.",
      cargadoError: "Error uploading the file.",
      advertenciaEstado: "The order is not in a valid state to upload a file.",
      noDatos: "No data loaded.",
      guardadoExito: "Data saved successfully.",
      guardadoError: "Error saving data.",
    },
    zh: {
      titulo: "上传装箱单",
      subir: "上传文件",
      selarchivo: "选择文件",
      cancelar: "取消",
      guardar: "保存",
      advertencia: "警告",
      errorArchivo: "请选择要上传的文件。",
      cargadoExito: "文件上传成功。",
      cargadoError: "上传文件时出错。",
      advertenciaEstado: "订单状态无效，无法上传文件。",
      noDatos: "未加载数据。",
      guardadoExito: "数据保存成功。",
      guardadoError: "保存数据时出错。",
    },
  };

  const t = translations[language] || translations.es;

  const isSubHeaderRow = (row) => {
    const s = String(row?.nroCaja ?? "")
      .toLowerCase()
      .replace(/\u00A0/g, " ") // normaliza NBSP
      .replace(/\s+/g, " ") // colapsa espacios y saltos de línea
      .replace(/[（）]/g, "()") // paréntesis chinos -> ()
      .trim();
    return /ctn\s*number/.test(s);
  };

  /*********evento para limpiar los estados al cerrar el modal**************************/
  const handleClose = () => {
    setSelectedFile(null);
    setPreviewData([]); // Limpiar la tabla
    onClose(); // Llama a la función original que cierra el modal
  };

  /**************totales de mercancia y array para mostrarlos************************* */
  /* const sumaCMBTotal = previewData.reduce((acc, row) => {
    const valor = parseFloat(row.CBMTotal) || 0; // Convierte a número, usa 0 si es NaN
    return acc + valor; // Suma el valor al acumulador
  }, 0);
  const sumaTotalCajas = previewData.reduce((acc, row) => {
    const valorCajas = parseFloat(row.CantCajas) || 0; // Convierte a número, usa 0 si es NaN
    return acc + valorCajas; // Suma el valor al acumulador
  }, 0); */
  /* const tiposMciaTotales = previewData.reduce((acc, row) => {
    const tipo = row.TipoMcia || "Sin Tipo"; // Asegúrate de que haya un valor válido
    acc[tipo] = (acc[tipo] || 0) + 1; // Incrementa el contador del tipo
    return acc;
  }, {}); */

  // const tiposMciaArray = Object.entries(tiposMciaTotales).map(([tipo, cantidad]) => `${tipo}: ${cantidad}`);

  /**************cargar el archivo************************* */
  const handleUpload = async () => {
    flushSync(() => {
      setLoading(true);
    });
    // Yielding del hilo principal para asegurar que el paint ocurra.
    await new Promise((resolve) => setTimeout(resolve, 0));

    if (!selectedFile) {
      setLoading(false);
      toast.current.show({
        severity: "warn",
        summary: t.advertencia,
        detail: t.errorArchivo,
      });
      return;
    }

    if (!["CREADO", "LE_OK"].includes(pedido.sNombreEstadoPedido)) {
      setLoading(false);
      toast.current.show({
        severity: "warn",
        summary: t.advertencia,
        detail: t.advertenciaEstado,
      });
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("idPedido", pedido.idpedido); // [EXPERT_ANALYSIS]: QUÉ: Se cambió el nombre del campo de 'idpedido' a 'idPedido'. - POR QUÉ: Para asegurar que el nombre del campo enviado en el FormData desde el frontend coincida exactamente con el nombre de la propiedad que el backend espera recibir ('idPedido' con 'P' mayúscula) en la ruta '/upload-temporal'. - IMPACTO: Corrige el error "ID de pedido inválido o faltante" al cargar archivos, permitiendo que el backend identifique correctamente el pedido asociado.

    try {
      const response = await fetchWithAuth(
        `${API_URL}/api/lista-empaque/upload-temporal`,
        {
          method: "POST",
          body: formData,
        },
      );

      if (response.ok) {
        const result = await response.json();
        console.log(
          "Datos recibidos del backend en CargarListaDeEmpaqueModal:",
          result.data,
        );

        /*         // Verificar si la primera fila es la de los sub-encabezados y eliminarla si es así
        if (result.data.length > 0 && result.data[0].nroCaja === "CTN Number (箱号)") {
          setPreviewData(result.data.slice(1)); // Eliminar la primera fila
          console.log("Primera fila de sub-encabezados eliminada.");
        } else {
          setPreviewData(result.data);
        }

        toast.current.show({
          severity: "success",
          summary: t.cargadoExito,
          detail: "",
        });
      } */
        const rows = Array.isArray(result.data) ? result.data : [];
        const first = rows[0];

        // >>> NUEVO: eliminar la fila de sub-encabezados si aparece
        setPreviewData(isSubHeaderRow(first) ? rows.slice(1) : rows);

        toast.current.show({
          severity: "success",
          summary: t.cargadoExito,
          detail: "",
        });
      } else {
        setPreviewData([]); // Limpiar previsualización en caso de error para evitar confusión
        const error = await response.json();
        const detailMessage =
          error.details && Array.isArray(error.details)
            ? error.details.slice(0, 5).join("\n") +
              (error.details.length > 5 ? "\n..." : "")
            : error.message || t.cargadoError;

        toast.current.show({
          severity: "error",
          summary: t.cargadoError,
          detail: detailMessage,
          life: 8000, // Mayor duración para leer detalles
        });
      }
    } catch (err) {
      toast.current.show({
        severity: "error",
        summary: t.cargadoError,
        detail: err.message || t.cargadoError,
        //detail: t.cargadoError,
      });
    } finally {
      setLoading(false);
    }
  };

  const onRowEditComplete = useCallback(
    (e) => {
      const { newData, index } = e;
      const updatedData = [...previewData];
      updatedData[index] = newData;
      setPreviewData(updatedData);
    },
    [previewData],
  );

  /**************Cuando se guarda************************* */
  const handleSave = async () => {
    flushSync(() => {
      setLoading(true);
    });
    // Yielding del hilo principal
    await new Promise((resolve) => setTimeout(resolve, 0));

    if (previewData.length === 0) {
      setLoading(false);
      toast.current.show({
        severity: "warn",
        summary: t.advertencia,
        detail: t.noDatos,
      });
      return;
    }
    try {
      const response = await fetchWithAuth(
        `${API_URL}/api/lista-empaque/save`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            idpedido: pedido.idpedido,
            data: previewData,
          }),
        },
      );
      console.log("Respuesta Response:", response); // [EXPERT_COMMENT]: Log de la respuesta del servidor para depuración.
      console.log("Datos enviados:", {
        idpedido: pedido.idpedido,
        data: previewData,
      }); // [EXPERT_COMMENT]: Log de los datos enviados al servidor para depuración.

      if (response.ok) {
        toast.current.show({
          severity: "success",
          summary: t.guardadoExito,
          detail: "",
        });
        if (onSaveSuccess) onSaveSuccess();
        handleClose(); // Limpiar y cerrar el modal después de guardar
      } else {
        const error = await response.json();
        const detailMessage =
          error.details && Array.isArray(error.details)
            ? error.details.slice(0, 5).join("\n") +
              (error.details.length > 5 ? "\n..." : "")
            : error.message || t.guardadoError;

        toast.current.show({
          severity: "error",
          summary: t.guardadoError,
          detail: detailMessage,
          life: 8000,
        });
      }
    } catch (err) {
      toast.current.show({
        severity: "error",
        summary: t.guardadoError,
        detail: t.guardadoError,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <LoadingOverlay message="Procesando datos..." />}
      <Dialog
        header={t.titulo}
        visible={isOpen}
        style={{ width: "85vw" }}
        breakpoints={{ "1200px": "90vw", "960px": "95vw", "640px": "98vw" }}
        modal
        onHide={handleClose}
      >
        <Toast ref={toast} />

        {/* Contenedor superior */}
        <div className="header-container">
          {/* Botones de acción */}
          <div className="upload-container">
            <FileUpload
              id="cargar-le-fileupload" // ID descriptivo
              mode="basic"
              name="file"
              accept=".csv,.xls,.xlsx"
              maxFileSize={10000000}
              onSelect={(e) => setSelectedFile(e.files[0])}
              auto={false}
              chooseLabel={t.selarchivo}
            />
            <Button
              id="btn-cargar-le-subir" // ID descriptivo
              label={t.subir}
              icon="pi pi-upload"
              className="p-button-success"
              onClick={handleUpload}
            />
          </div>
          {/* {selectedFile && (
          <div className="file-name-display">
            Archivo seleccionado: <strong>{selectedFile.name}</strong>
          </div>
        )} */}

          <TotalesEncabezadoListaEmpaque
            pedido={pedido}
            previewData={previewData}
          />
        </div>

        {/* Tabla de datos memoizada para evitar lag visual al activar loading */}
        {useMemo(
          () =>
            previewData.length > 0 && (
              <DataTable
                value={previewData}
                editable
                scrollable
                scrollHeight="400px"
                tableStyle={{ minWidth: "2200px" }}
                editMode="row"
                onRowEditComplete={onRowEditComplete}
              >
                {columnasEsperadas.map((col) => (
                  <Column
                    key={col.field}
                    field={col.field}
                    header={col.header}
                    style={{
                      minWidth: col.width,
                      textAlign: "center",
                    }}
                    editor={(options) => (
                      <InputText
                        type="text"
                        value={options.value}
                        onChange={(e) => options.editorCallback(e.target.value)}
                      />
                    )}
                  />
                ))}
                <Column
                  rowEditor
                  headerStyle={{ width: "10%", minWidth: "100px" }}
                  bodyStyle={{ textAlign: "center" }}
                />
              </DataTable>
            ),
          [previewData, onRowEditComplete, columnasEsperadas],
        )}

        {/* Footer con botones */}
        <div className="p-dialog-footer">
          <Button
            id="btn-cargar-le-guardar" // ID descriptivo
            label={t.guardar}
            icon="pi pi-save"
            className="p-button-success"
            onClick={handleSave}
          />
          <Button
            id="btn-cargar-le-cancelar" // ID descriptivo
            label={t.cancelar}
            icon="pi pi-times"
            className="p-button-secondary"
            onClick={handleClose}
          />
        </div>
      </Dialog>
    </>
  );
};

export default CargarListaDeEmpaqueModal;
